// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__A7FAx","wide":"Container_wide__DEeFc","twocolumns":"Container_twocolumns__4QQMa","threecolumns":"Container_threecolumns__etCNB"};